interface SharingPlatform {
  share?: (data: ShareData) => Promise<void>
  clipboard?: { writeText: (text: string) => Promise<void> }
}
/** Cancellation is normal. Clipboard failure is surfaced with a selectable link. */
export async function deliverShare(
  url: string,
  native: boolean,
  platform: SharingPlatform = navigator,
): Promise<'copied' | 'shared' | 'cancelled'> {
  try {
    if (native && platform.share) {
      await platform.share({ title: 'Listen on Tunes', url })
      return 'shared'
    }
    if (!platform.clipboard) throw new Error('Clipboard unavailable')
    await platform.clipboard.writeText(url)
    return 'copied'
  } catch (error) {
    if ((error as Error).name === 'AbortError') return 'cancelled'
    throw error
  }
}
